import * as React from 'react';
const FlowDoctorHandlerContext = /*#__PURE__*/React.createContext({});
export const FlowDoctorHandlerContextProvider = FlowDoctorHandlerContext.Provider;
export default FlowDoctorHandlerContext;